import { render, staticRenderFns } from "./DialogoDesconectados.vue?vue&type=template&id=2c092056&scoped=true"
import script from "./DialogoDesconectados.vue?vue&type=script&lang=ts"
export * from "./DialogoDesconectados.vue?vue&type=script&lang=ts"
import style0 from "./DialogoDesconectados.vue?vue&type=style&index=0&id=2c092056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c092056",
  null
  
)

export default component.exports